import { useTranslation } from "react-i18next";

interface MetaProps {
  author: string;
  publishedDate: string;
  changedDate?: string;
  articleNumber?: string | null;
}

const Meta = ({
  author,
  publishedDate,
  changedDate,
  articleNumber,
}: MetaProps) => {
  const { t } = useTranslation("common");

  return (
    <ul className="pubr-reader-meta">
      <li className="pubr-reader-meta__item">
        {`${t("published")}: ${publishedDate}`}
      </li>
      {changedDate !== null && changedDate !== "" && (
        <li className="pubr-reader-meta__item">
          {`${t("updated")}: ${changedDate}`}
        </li>
      )}
      {articleNumber !== null && articleNumber !== "" && (
        <li className="pubr-reader-meta__item">
          {`${t("articleNumber")}: ${articleNumber}`}
        </li>
      )}
      <li className="pubr-reader-meta__item">{author}</li>
    </ul>
  );
};

export { Meta };
